<ng-template #template let-row="row">
  <div
    class="project-responsible-company-cell no-select"
    [matTooltip]="row?.basicDataBox?.responsibleEmployee?.userPerson?.previewName || ''"
    matTooltipPosition="above"
    matTooltipShowDelay="1000"
  >
    {{ row?.basicDataBox?.responsibleEmployee?.userPerson?.previewName ?? '-' }}
  </div>
</ng-template>
